<p><a routerLink="/DashboardStandard1">Calls Breakdown Report</a></p>
<p><a routerLink="/MissedCallsReport">Missed Calls Report</a></p>



<p>Customisable Reports</p>
<!--{{reports | async | json}}-->

<ng-container *ngIf="reports | async as _reports else loading">

  <button mat-icon-button color="warn" aria-label="Create Report" routerLink="/CustomisableReports">
    <mat-icon>add_circle</mat-icon>
  </button>

  <table>
    <tr>
      <!--<td>ID</td>-->
      <td>Name</td>
      <!--<td>CompanyId</td>
      <td>Data</td>-->
      <td>CreateDate</td>
      <td>Delete</td>
    </tr>
    <tr *ngFor="let row of _reports">
      <!--<td>
        <a routerLink="/CustomisableReports/{{row.iD}}">{{row.iD}}</a>
      </td>-->
      <td>
        <a routerLink="/CustomisableReports/{{row.iD}}">{{row.name}}</a>
      </td>
      <!--<td>{{row.companyId}}</td>
      <td>{{row.data}}</td>-->
      <td>{{row.createDate}}</td>
      <td>
        <button mat-icon-button color="warn" aria-label="Remove Report" (click)="deleteReport(row.iD, _reports)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </tr>
  </table>
</ng-container>

<ng-template #loading>
  loading ...
</ng-template>
